export const AdditionalValesTableMenuItems = [
  {
    label: 'Edit',
    key: 'edit'
  },
  {
    label: 'Delete',
    key: 'delete'
  }
]
